import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  position: absolute;
  background: #FFFFFF;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgb(0 0 0 / 8%);
  z-index: 10;
  bottom: 20px;
  right: 0px;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E3E3E3;
`

export default Wrapper(template)